import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="bg-white/80 backdrop-blur-md border-t border-gray-200 py-12 px-6 mt-auto">
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="flex flex-col">
                    <div className="flex items-center gap-2 mb-4">
                        <img src="/logo.svg" alt="Akhandaa Logo" className="h-8 w-auto object-contain" />
                        <img
                            src="/Akhandaa.svg"
                            alt="Akhandaa"
                            className="h-5 w-auto object-contain"
                        />
                    </div>
                    <p className="text-gray-500 text-sm">Your path to divine discoveries</p>
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 mb-4">Quick Links</h3>
                    <ul className="space-y-3 text-sm text-gray-600 font-medium">
                        <li><Link to="/" className="hover:text-sky-600 transition">Home</Link></li>
                        <li><Link to="/about" className="hover:text-sky-600 transition">About Us</Link></li>
                        <li><Link to="/blogs" className="hover:text-sky-600 transition">Blog</Link></li>
                        <li><Link to="/terms" className="hover:text-sky-600 transition">Terms & Conditions</Link></li>
                        <li><Link to="/privacy" className="hover:text-sky-600 transition">Privacy Policy</Link></li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 mb-4">Sacred Yatras</h3>
                    <ul className="space-y-3 text-sm text-gray-600 font-medium">
                        <li><Link to="/char-dham-yatra" className="hover:text-sky-600 transition">Char Dham Yatra</Link></li>
                        <li><Link to="/amarnath-yatra" className="hover:text-sky-600 transition">Amarnath Yatra</Link></li>
                        <li><Link to="/pancha-bhoota-sthalam" className="hover:text-sky-600 transition">Pancha Bhoota Sthalam</Link></li>
                        <li><Link to="/arupadai-veedu" className="hover:text-sky-600 transition">Arupadai Veedu</Link></li>
                        <li><Link to="/mukti-kshetras-karnataka" className="hover:text-sky-600 transition">Karnataka Mukti Kshetras</Link></li>
                        <li><Link to="/shakti-peethas" className="hover:text-sky-600 transition">Shakti Peethas</Link></li>
                        <li><Link to="/jyotirlingas" className="hover:text-sky-600 transition">Jyotirlingas</Link></li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 mb-4">Contact Info</h3>
                    <ul className="space-y-3 text-sm text-gray-600 font-medium">
                        <li className="flex items-center gap-2">
                            <span className="text-sky-600">✉️</span>
                            <a href="mailto:akhandaaservice@gmail.com" className="hover:text-sky-600 transition">akhandaaservice@gmail.com</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-gray-100 text-center text-gray-400 text-xs font-semibold tracking-widest uppercase">
                &copy; {new Date().getFullYear()} AKHANDAA. ALL RIGHTS RESERVED.
            </div>
        </footer>
    );
};

export default Footer;
